/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import UpdateAxios from "../../axiosComponent/update";
import { DateData } from "../../dynamicComponent/datepick";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { setMinutes, setHours } from "date-fns";
import moment from 'moment';
import MyConsigneeComponent from "../../dynamicComponent/consigneeName";
import { translate } from "react-i18next";
import SearchDropdown from "../../createShipmentComponent/searchDropdown";
import cogoToast from "cogo-toast";

const ModalDropDetails = ({ values, isSubmitting, handleSubmit, delivery_status, delivery_details, setFieldValue, t, drop_location }) => {
  const [modalOpen, setmodalOpen] = useState(false);

  let handleOpen = () => setmodalOpen(true);
  let handleClose = () => {
    setmodalOpen(false);
  };
  let handleSubmited = () => {
    setmodalOpen(false);
    if (values.container_return_date) handleSubmit();
  };

  const filterPassedTime = time => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  }

  return (
    <div>
      <Modal
        style={{ overflow: "inherit" }}
        open={modalOpen}
        onClose={handleClose}
        size="mini"
        trigger={
          <Button
          basic
            type="button"
            style={{ width: "100%" }}
            onClick={handleOpen}
            size="mini"
            color="blue"
            className="p-bold-600 ml-2 mr-2 "
            disabled={delivery_status == "DROPPED" ? true : false}

          >
            {t("Drop_Details") || "Drop Details"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          <div className="d-flex justify-content-between">
            <label className="mt-2 font-weight-normal">{t("Container_drop_details") || "Container Drop details"}</label>
            <div className="form-inline">
              <i onClick={handleClose} className="fas fa-times"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <div className="ui form">
              <FormUi.Field>
                <label className="labelName">{t("Drop_Location") || "Drop Location"}</label>
              </FormUi.Field>
              <SearchDropdown
                setField={(name, value) => setFieldValue(`drop_location`, value.raw ? value.raw.consigneeName : null)}
                masterRoute="consigneeMaster"
                masterRouteKey="consigneeId"
                masterRouteName="consigneeName"
                fieldName="drop_location"
                deafultValue={drop_location}
              />
              <FormUi.Field>

              </FormUi.Field>
              <FormUi.Field>
                <label className="labelName">{t("Date_time") || "Date & Time"}</label>
              </FormUi.Field>
              <FormUi.Field>
                <DateData
                  name="container_return_date"
                  autoComplete="off"
                  showTimeSelect
                  timeFormat="HH:mm"
                  minDate={delivery_status == "DLVRD" ? new Date(delivery_details.actual_delivery_date) : ""}
                  popperClassName="dateTime"
                  dateFormat="dd/MM/yyyy HH:mm"
                  customInput={
                    <FormUi.Input
                      icon="time"
                      className="dateWidth"
                      iconPosition="left"
                    />
                  }
                />
              </FormUi.Field>

            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          <Button
            type="submit"
            onClick={handleSubmited}
            disabled={isSubmitting || values.container_return_date ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("action_button.submit") || "Submit"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
const FormikDropDetails = withFormik({
  mapPropsToValues(props) {
    return {
      container_return_date: new Date(),
      drop_location: props.drop_location || ""
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    let URL = ""
    if (moment.parseZone(values.container_return_date).format('YYYY-MM-DD HH:mm') < moment.parseZone(props.delivery_details.actual_delivery_date).format('YYYY-MM-DD HH:mm') && props.delivery_details.actual_delivery_date != null) {
      // console.log("TEST :", values.container_return_date, props.delivery_details.actual_delivery_date, props);
      cogoToast.error("Selected time less than actual delivery time")
      setSubmitting(false)
    }
    else {
      console.log("TEST else:", values.container_return_date, props.delivery_details.actual_delivery_date);
      values.container_return_date = moment.parseZone(values.container_return_date).format('YYYY-MM-DD HH:mm')
      URL = `${process.env.REACT_APP_TA_API_URL}/deliveries/${props.delivery_id}/drop/location`
    }
    UpdateAxios({
      patchURL: URL, payload: values,
    })
      .then((res) => {
        setSubmitting(false);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: err.message,
        });
      });
  },
})(ModalDropDetails);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("allot")(FormikDropDetails)
);
